module.exports = __webpack_public_path__ + "img/9791187038627.0d7ed7d5.jpg";